export default "__VITE_ASSET__RhdlOtsh__"